// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login_navigation {
    display: flex;
    justify-content: space-around;
    align-items: center;
    padding: 10px 20px;
    width: 50%;
    margin: auto;
    font-size: 16px;
    font-weight: 700;
}

.login_active {
    position: relative;
    /* OBLIGATOIRE */
    color: var(--couleur-secondaire);
}

.login_active::after {
    content: "";
    position: absolute;
    left: 50%;
    bottom: -6px;
    width: 80%;
    height: 3px;
    background-color: var(--couleur-secondaire);
    transform: translateX(-50%);
}

.login_welcome {
    text-align: center;
    margin-top: 30px;
    margin-bottom: 30px;
}

.login_welcom h1 {
    font-size: 32px;
    font-weight: 700;
    color: var(--couleur-dark);
}

.login_welcome p {
    font-size: 16px;
    margin-bottom: 10px;
    color: var(--couleur-principale);
}

.login_social_buttons {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 20px;
    margin-bottom: 20px;
}

.login_social_buttons button {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    padding: 10px;
    border-radius: 10px;
    border: solid 1px var(--gris-secondaire);
    background-color: var(--gris-secondaire);
    cursor: pointer;
    width: 50%;
    color: var(--couleur-dark);
    height: 58px;
    border-radius: 100px;
    font-size: 16px;
    font-weight: 400;
}

.login_social_buttons button img {
    width: 20px;
    height: 20px;
}

.login_form {
    display: flex;
    flex-direction: column;
    gap: 15px;
    width: 50%;
    margin: auto;
}

.login_form p,
span {
    font-size: 14px;
    color: var(--couleur-dark);
    margin-left: 10px;
    font-weight: 400;
}

.login_radio_group {
    display: flex;
    justify-content: space-between;
    gap: 10px;
    align-items: center;
    width: 50%;
}

.login_input_text {
    padding: 15px;
    border-radius: 100px;
    border: solid 1px var(--gris-principale);
    font-size: 16px;
}

.login_validate {
    background-color: var(--couleur-principale);
    border: solid 2px var(--couleur-principale);
    border-radius: 100px;
    padding: 10px;
    color: var(--white-principale);
    margin-top: 20px;
    cursor: pointer;
    font-size: 16px;
}

.login_validate:hover {
    background-color: var(--couleur-secondaire);
    border: solid 2px var(--couleur-secondaire);
}

.login_hr {
    width: 50%;
    color: var(--couleur-dark);
    margin: auto;
    margin-bottom: 40px;
    margin-top: 40px;
}

.login_icon_x {
    position: absolute;
    top: 40px;
    right: 100px;
    font-size: 28px;
    color: var(--couleur-secondaire);
}

.login_row_between {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 10px;
}

.login_forgot_password {
    font-size: 14px;
    color: #2563eb;
    font-weight: 600;
    cursor: pointer;
    transition: opacity .15s ease, transform .15s ease;
}

.login_forgot_password:hover {
    opacity: .85;
    transform: translateY(-1px);
    text-decoration: underline;
}


@media (max-width: 769px) {
    .login_navigation {
        width: 100%;
    }

    .login_navigation div {
        margin: 5px;
    }

    .login_social_buttons button {
        width: 100%;
    }

    .login_form {
        width: 100%;
        padding-left: 10px;
        padding-right: 10px;
    }

    .login_icon_x {
        top: 5px;
        right: 5px;
    }
}

@media (max-width: 992px) {
    .login_navigation {
        width: 100%;
    }
}`, "",{"version":3,"sources":["webpack://./src/assets/css/authentification/login.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,6BAA6B;IAC7B,mBAAmB;IACnB,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,gCAAgC;AACpC;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,YAAY;IACZ,UAAU;IACV,WAAW;IACX,2CAA2C;IAC3C,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;IACT,aAAa;IACb,mBAAmB;IACnB,wCAAwC;IACxC,wCAAwC;IACxC,eAAe;IACf,UAAU;IACV,0BAA0B;IAC1B,YAAY;IACZ,oBAAoB;IACpB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,UAAU;IACV,YAAY;AAChB;;AAEA;;IAEI,eAAe;IACf,0BAA0B;IAC1B,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,mBAAmB;IACnB,UAAU;AACd;;AAEA;IACI,aAAa;IACb,oBAAoB;IACpB,wCAAwC;IACxC,eAAe;AACnB;;AAEA;IACI,2CAA2C;IAC3C,2CAA2C;IAC3C,oBAAoB;IACpB,aAAa;IACb,8BAA8B;IAC9B,gBAAgB;IAChB,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,2CAA2C;IAC3C,2CAA2C;AAC/C;;AAEA;IACI,UAAU;IACV,0BAA0B;IAC1B,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,YAAY;IACZ,eAAe;IACf,gCAAgC;AACpC;;AAEA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,kDAAkD;AACtD;;AAEA;IACI,YAAY;IACZ,2BAA2B;IAC3B,0BAA0B;AAC9B;;;AAGA;IACI;QACI,WAAW;IACf;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,WAAW;QACX,kBAAkB;QAClB,mBAAmB;IACvB;;IAEA;QACI,QAAQ;QACR,UAAU;IACd;AACJ;;AAEA;IACI;QACI,WAAW;IACf;AACJ","sourcesContent":[".login_navigation {\n    display: flex;\n    justify-content: space-around;\n    align-items: center;\n    padding: 10px 20px;\n    width: 50%;\n    margin: auto;\n    font-size: 16px;\n    font-weight: 700;\n}\n\n.login_active {\n    position: relative;\n    /* OBLIGATOIRE */\n    color: var(--couleur-secondaire);\n}\n\n.login_active::after {\n    content: \"\";\n    position: absolute;\n    left: 50%;\n    bottom: -6px;\n    width: 80%;\n    height: 3px;\n    background-color: var(--couleur-secondaire);\n    transform: translateX(-50%);\n}\n\n.login_welcome {\n    text-align: center;\n    margin-top: 30px;\n    margin-bottom: 30px;\n}\n\n.login_welcom h1 {\n    font-size: 32px;\n    font-weight: 700;\n    color: var(--couleur-dark);\n}\n\n.login_welcome p {\n    font-size: 16px;\n    margin-bottom: 10px;\n    color: var(--couleur-principale);\n}\n\n.login_social_buttons {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    gap: 20px;\n    margin-bottom: 20px;\n}\n\n.login_social_buttons button {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 10px;\n    padding: 10px;\n    border-radius: 10px;\n    border: solid 1px var(--gris-secondaire);\n    background-color: var(--gris-secondaire);\n    cursor: pointer;\n    width: 50%;\n    color: var(--couleur-dark);\n    height: 58px;\n    border-radius: 100px;\n    font-size: 16px;\n    font-weight: 400;\n}\n\n.login_social_buttons button img {\n    width: 20px;\n    height: 20px;\n}\n\n.login_form {\n    display: flex;\n    flex-direction: column;\n    gap: 15px;\n    width: 50%;\n    margin: auto;\n}\n\n.login_form p,\nspan {\n    font-size: 14px;\n    color: var(--couleur-dark);\n    margin-left: 10px;\n    font-weight: 400;\n}\n\n.login_radio_group {\n    display: flex;\n    justify-content: space-between;\n    gap: 10px;\n    align-items: center;\n    width: 50%;\n}\n\n.login_input_text {\n    padding: 15px;\n    border-radius: 100px;\n    border: solid 1px var(--gris-principale);\n    font-size: 16px;\n}\n\n.login_validate {\n    background-color: var(--couleur-principale);\n    border: solid 2px var(--couleur-principale);\n    border-radius: 100px;\n    padding: 10px;\n    color: var(--white-principale);\n    margin-top: 20px;\n    cursor: pointer;\n    font-size: 16px;\n}\n\n.login_validate:hover {\n    background-color: var(--couleur-secondaire);\n    border: solid 2px var(--couleur-secondaire);\n}\n\n.login_hr {\n    width: 50%;\n    color: var(--couleur-dark);\n    margin: auto;\n    margin-bottom: 40px;\n    margin-top: 40px;\n}\n\n.login_icon_x {\n    position: absolute;\n    top: 40px;\n    right: 100px;\n    font-size: 28px;\n    color: var(--couleur-secondaire);\n}\n\n.login_row_between {\n    width: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin-top: 10px;\n}\n\n.login_forgot_password {\n    font-size: 14px;\n    color: #2563eb;\n    font-weight: 600;\n    cursor: pointer;\n    transition: opacity .15s ease, transform .15s ease;\n}\n\n.login_forgot_password:hover {\n    opacity: .85;\n    transform: translateY(-1px);\n    text-decoration: underline;\n}\n\n\n@media (max-width: 769px) {\n    .login_navigation {\n        width: 100%;\n    }\n\n    .login_navigation div {\n        margin: 5px;\n    }\n\n    .login_social_buttons button {\n        width: 100%;\n    }\n\n    .login_form {\n        width: 100%;\n        padding-left: 10px;\n        padding-right: 10px;\n    }\n\n    .login_icon_x {\n        top: 5px;\n        right: 5px;\n    }\n}\n\n@media (max-width: 992px) {\n    .login_navigation {\n        width: 100%;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
